<div class="table-container shadow">
  <table class="subscription-plans-table">
    <thead>
      <tr>
        <th class="checkbox-col">
          <input
            type="checkbox"
            [checked]="allSelected"
            (change)="toggleSelectAll()" />
          </th>
          <th class="sortable" (click)="onSort('name')">Plan Name <span class="sort-indicator">{{ getSortIcon('name') }}</span></th>
          <th class="sortable" (click)="onSort('price')">Price <span class="sort-indicator">{{ getSortIcon('price') }}</span></th>
          <th>Status</th>
          <th>Key Features</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        @if (loader()) {
          <tr>
            <td colspan="100%">
              <app-spinner-loader [width]="35" />
            </td>
          </tr>
        } @else if (plans().length === 0) {
          <tr>
            <td colspan="100%" class="no-data-cell">No subscriptions found</td>
          </tr>
        } @else {
          @for (plan of plans(); track plan; let i = $index) {
            <tr [class.selected]="plan.selected">
              <td class="checkbox-col">
                <input
                  type="checkbox"
                  [(ngModel)]="plan.selected"
                  (change)="updateSelectAllState()" />
                </td>
                <td class="plan-name">{{ plan.name }}</td>
                <td class="price">{{ plan.price | currency: plan.currency :'symbol':'1.2-2' }} {{ getFrequencyLabel(plan.duration) }}</td>
                <td class="plan-status">
                  <span class="badge" [ngClass]="plan.isActive ? 'bg-success' : 'bg-secondary'">
                    {{ plan.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td class="plan-features">{{ (plan.features || []).join(', ') || 'None' }}</td>
                <td class="text-center">
                  <button class="btn btn-view" (click)="viewDetails(plan)">
                    View
                  </button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <app-plan-modal [isVisible]="isView()" [plan]="selectedPlan()" (close)="closeViewDetails($event)"></app-plan-modal>